import React from 'react';
import { Col, Row } from 'react-bootstrap';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import {
  PlanRemarksTable,
  PlanServicesMinutesTable,
  PlanServicesReachabilityTable,
  PlanServicesTable,
} from '@components/Order/Numbers/Tables';
import { Page500 } from '@containers/ErrorPages';
import { numberApi } from '@reducers/number/number';

export const ServicesTab = ({ did }) => {
  const {
    data: result,
    isLoading,
    status,
  } = numberApi.useGetForServicesQuery({ did });
  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }
  if (status === 'rejected') {
    return <Page500 />;
  }
  return (
    <>
      <Row>
        <Col md={4}>
          <PlanServicesReachabilityTable data={[result.reachability]} />
        </Col>
        <Col md={4}>
          <PlanServicesTable data={[result.services]} />
        </Col>
        <Col md={4}>
          <PlanServicesMinutesTable data={[result.minutes]} />
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <PlanRemarksTable data={[{ remarks: result.remarks }]} />
        </Col>
      </Row>
    </>
  );
};
